import { Box, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React from 'react';

type SvgIconElement = React.ReactElement<React.ComponentProps<'svg'>>;

interface ImsDoubleRectButtonProps {
  icon: SvgIconElement;
  selected: boolean;
  onClick: () => void;
}

const ImsDoubleRectButton: React.FC<ImsDoubleRectButtonProps> = ({
  icon,
  selected,
  onClick,
}) => {
  // Extract conditional style values
  const activeColor = selected ? '#009fe3' : '#9B9B9B';
  const bgColor = selected ? '#00a8e3' : '#e0e0e0';
  const hoverBgColor = selected ? '#009fe3' : '#9B9B9B';

  // Define outer and inner style objects
  const outerSx: SystemStyleObject<Theme> = {
    width: 80,
    height: 80,
    borderRadius: 2,
    backgroundColor: bgColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: '0.2s',
    '&:hover': {
      backgroundColor: hoverBgColor,
    },
  };

  const innerSx: SystemStyleObject<Theme> = {
    width: '60%',
    height: '60%',
    borderRadius: 1,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  // Prepare the icon's style
  const iconStyle: React.CSSProperties = {
    fill: activeColor, 
    stroke: activeColor,
    color: activeColor, 
    ...(icon.props.style as React.CSSProperties || {}),
  };

  // Clone the icon element with the updated dimensions and style
  const styledIcon = React.cloneElement(icon, {
    width: 24,
    height: 24,
    style: iconStyle,
  }) as React.ReactElement;

  return (
    <Box onClick={onClick} sx={outerSx}>
      <Box sx={innerSx}>
        {styledIcon}
      </Box>
    </Box>
  );
};

export default ImsDoubleRectButton;